import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, Fragment as _Fragment, withModifiers as _withModifiers, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "step-body"
}
const _hoisted_2 = { class: "body-content" }
const _hoisted_3 = { class: "form-group school-selection" }
const _hoisted_4 = {
  key: 0,
  class: "submit-error"
}
const _hoisted_5 = {
  key: 1,
  class: "step-body"
}
const _hoisted_6 = {
  key: 0,
  class: "body-content"
}
const _hoisted_7 = { class: "form-group" }
const _hoisted_8 = { class: "form-check" }
const _hoisted_9 = {
  class: "form-check-label",
  for: "schoolName"
}
const _hoisted_10 = { class: "form-group" }
const _hoisted_11 = { class: "form-check" }
const _hoisted_12 = {
  class: "form-check-label",
  for: "schoolState"
}
const _hoisted_13 = {
  key: 1,
  class: "submit-error"
}
const _hoisted_14 = {
  key: 3,
  class: "footer-wrapper"
}
const _hoisted_15 = { class: "step-btns" }
const _hoisted_16 = ["disabled"]
const _hoisted_17 = ["disabled"]
const _hoisted_18 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Loader = _resolveComponent("Loader")!
  const _component_base_form_field = _resolveComponent("base-form-field")!
  const _component_dialogue_modal = _resolveComponent("dialogue-modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.loading)
      ? (_openBlock(), _createBlock(_component_Loader, {
          key: 0,
          inverse: true
        }))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          (_ctx.editSchool)
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _cache[6] || (_cache[6] = _createElementVNode("p", { class: "step-title" }, "Choose a School", -1)),
                _cache[7] || (_cache[7] = _createElementVNode("p", { class: "step-desc" }, "Please choose the school you will be attending.", -1)),
                _createElementVNode("div", _hoisted_2, [
                  _createElementVNode("div", _hoisted_3, [
                    _createVNode(_component_base_form_field, {
                      modelValue: _ctx.newSchool.school,
                      "onUpdate:modelValue": [
                        _cache[0] || (_cache[0] = ($event: any) => ((_ctx.newSchool.school) = $event)),
                        _cache[1] || (_cache[1] = ($event: any) => (_ctx.getSchool($event)))
                      ],
                      schema: _ctx.changeSchoolSchema.school,
                      autocompleteOptions: _ctx.schools,
                      class: _normalizeClass({
              'is-invalid': _ctx.newSchool.school?.id === null,
            })
                    }, null, 8, ["modelValue", "schema", "autocompleteOptions", "class"])
                  ])
                ]),
                (_ctx.GetErrorMessage.length > 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                      _createElementVNode("p", null, _toDisplayString(_ctx.GetErrorMessage), 1)
                    ]))
                  : _createCommentVNode("", true)
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _cache[10] || (_cache[10] = _createElementVNode("p", { class: "step-title" }, "School Information", -1)),
                _cache[11] || (_cache[11] = _createElementVNode("p", { class: "step-desc" }, "Confirm the information below", -1)),
                (!_ctx.editSchool)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                      _createElementVNode("div", _hoisted_7, [
                        _cache[8] || (_cache[8] = _createElementVNode("label", null, "School Name", -1)),
                        _createElementVNode("div", _hoisted_8, [
                          _createElementVNode("label", _hoisted_9, _toDisplayString(_ctx.SchoolName), 1)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_10, [
                        _cache[9] || (_cache[9] = _createElementVNode("label", null, "School State", -1)),
                        _createElementVNode("div", _hoisted_11, [
                          _createElementVNode("label", _hoisted_12, _toDisplayString(_ctx.SchoolStateName), 1)
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.GetErrorMessage.length > 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                      _createElementVNode("p", null, _toDisplayString(_ctx.GetErrorMessage), 1)
                    ]))
                  : _createCommentVNode("", true)
              ]))
        ], 64)),
    (_ctx.showDialogueModal === true)
      ? (_openBlock(), _createBlock(_component_dialogue_modal, {
          key: 2,
          onCancel: _cache[2] || (_cache[2] = ($event: any) => (_ctx.showDialogueModal = false)),
          onConfirm: _ctx.handleDialogueModal,
          title: `Quit editing?`,
          msg: `Any changes you\'ve made so far will not be saved`,
          confirmButtonText: 'Yes',
          cancelButtonText: 'No'
        }, null, 8, ["onConfirm"]))
      : _createCommentVNode("", true),
    (!_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-secondary",
              disabled: _ctx.loading,
              onClick: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.cancelButton && _ctx.cancelButton(...args)), ["prevent"]))
            }, _toDisplayString(_ctx.editSchool ? "Cancel" : "Close"), 9, _hoisted_16),
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-primary btn-sm cuscd-button-color-cta",
              disabled: _ctx.loading || (_ctx.editSchool && !_ctx.validSchool),
              onClick: _cache[4] || (_cache[4] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.confirmSchool && _ctx.confirmSchool(...args)), ["prevent"]))
            }, _toDisplayString(_ctx.editSchool ? "Select" : "Confirm"), 9, _hoisted_17)
          ]),
          _withDirectives(_createElementVNode("a", {
            class: "change-school-link",
            disabled: _ctx.loading,
            onClick: _cache[5] || (_cache[5] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.changeSchool && _ctx.changeSchool(...args)), ["prevent"]))
          }, " Or, change your school ", 8, _hoisted_18), [
            [_vShow, !_ctx.editSchool]
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}